import React from 'react'
import LoaderButton from '../../components/LoaderButton'
import FormViewer from '../../components/FormViewer'
import { translate } from '../../utils/useful'
import ButtonAnimated from '../../components/buttons/ButtonAnimated'
import { getAllInfoByISO } from 'iso-country-currency'
import { countriesList } from '../../variables/countries'
// import HttpService from '../../utils/Http.services';

class LoginInfoStep extends React.Component {
    state = {
        errors: {},
        formHeaders: [
            { key: 'name', type: 'TextInput', information: { componentClass: 'name-input', placeholder: '{{lang}}insertName', autoFocus: true, required: true } },
            { key: 'family', type: 'TextInput', information: { componentClass: 'name-input', placeholder: '{{lang}}insertFamily', required: true } },
            { key: 'birthdate', type: 'DateInput', information: { placeholder: '{{lang}}birthdate', required: true } },
            { key: 'username', type: 'UsernameInput', information: { hint: '{{lang}}ch-username', minLenght: 4, address: 'checkUsernameValidity', placeholder: '{{lang}}username', required: true } },
            { key: 'password', type: 'PasswordInput', information: { placeholder: '{{lang}}insertPassword', required: true } },
            { key: 'country', type: 'SelectInput', information: { type: 'local', address: '', filter: {}, items: [{ title: countriesList.name, value: countriesList.code },], placeholder: '{{lang}}Country', required: true } },
            { key: 'currency', type: 'SelectInput', information: { type: 'local', address: '', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}Currency', required: true } },
            { key: 'timezone', type: 'MultiSelectInput', information: { type: 'local', address: '', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}Timezone', required: true } },
            // { key: 'gender', type: 'SelectInput', information: { type: 'local', items: [{ title: 'Male', value: 'Male' }, { title: 'Female', value: 'Female' }], placeholder: '{{lang}}gender', required: true } },
        ]
    }

    userPostInfo = () => {
        this.setState({ isLoading: true, errors: {} })
        let data = this.form.getForm()
        if (data) {
            this.props.setData(data, () => {
                this.props.userPostInfo((result, err) => {
                    if (err) { this.setState({ errors: err },) }
                    this.setState({ isLoading: false })
                })
            })
        } else { this.setState({ isLoading: false }) }
    }

    componentDidMount() {
        let countries = countriesList
        let formHeaders = [
            { key: 'name', type: 'TextInput', information: { componentClass: 'name-input', placeholder: '{{lang}}insertName', autoFocus: true, required: true } },
            { key: 'family', type: 'TextInput', information: { componentClass: 'name-input', placeholder: '{{lang}}insertFamily', required: true } },
            { key: 'birthdate', type: 'DateInput', information: { placeholder: '{{lang}}birthdate', required: true } },
            { key: 'username', type: 'UsernameInput', information: { hint: '{{lang}}ch-username', minLenght: 4, address: 'checkUsernameValidity', placeholder: '{{lang}}username', required: true } },
            { key: 'password', type: 'PasswordInput', information: { placeholder: '{{lang}}insertPassword', required: true } },
            // { key: 'country', type: 'SelectInput', information: { type: 'local', address: '', filter: {}, items: [{ title: countriesList.name, value: countriesList.code },], placeholder: '{{lang}}Country', required: true } },
            // { key: 'currency', type: 'SelectInput', information: { type: 'local', address: '', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}Currency', required: true } },
            // { key: 'timezone', type: 'MultiSelectInput', information: { type: 'local', address: '', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}Timezone', required: true } },
            // { key: 'gender', type: 'SelectInput', information: { type: 'local', items: [{ title: 'Male', value: 'Male' }, { title: 'Female', value: 'Female' }], placeholder: '{{lang}}gender', required: true } },
        ]
        let countriesItems = []
        let currenciesItems = []
        let defaultCountry = []
        countries.forEach(country => {
            if (country.code == this.props.initData.countryCode) {
                defaultCountry = { title: country.name, value: country.code }
            }
            let countryItem = { title: country.name, value: country.code }
            let currencyItem = { title: `${country.currency} (${country.symbol})`, value: country.code }
            // let title = country.name
            // let value = country.code
            countriesItems.push(countryItem)
            currenciesItems.push(currencyItem)
        });
        console.log('defaultCountry', defaultCountry)
        // let countryHeader = { key: 'country', type: 'AdvancedSelectInput', information: { type: 'local', items: countriesItems, placeholder: '{{lang}}Country', required: true } }
        // let currencyHeader = { key: 'currency', type: 'AdvancedSelectInput', information: { type: 'local', items: currenciesItems, placeholder: '{{lang}}Currency', required: true } }
        let header = [
            {
                key: 'country', type: 'SelectInput', information: {
                    type: 'local', items: countriesItems, placeholder: '{{lang}}Country',
                    defaultValue: this.props.initData.countryCode,
                    required: true
                }
            },
            {
                key: 'currency', type: 'SelectInput', information: { type: 'local', items: currenciesItems, placeholder: '{{lang}}Currency', required: true },
                dependencies: [{
                    refKey: 'country', targetKey: 'currency',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.country' }, operator: { value: '!=' }, target: { value: null } } }, },
                        effect: { show: true, changeValue: true }
                    }],
                    else: { show: true, changeHeader: [{}] },
                    init: true,
                    // show:true,

                }]
            }]
        // let timezoneHeader = { key: 'timezone', type: 'MultiSelectInput', information: { type: 'local', address: '', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}Timezone', required: true } }
        header.forEach(el => {
            formHeaders.push(el)
        });
        // formHeaders.push(countryHeader)
        // formHeaders.push(currencyHeader)
        // formHeaders.push(timezoneHeader)
        this.setState({ formHeaders })
        // let countries = this.state.country
        // for (let i = 0; i < countries.length; i++) {
        //     const element = countries[i];
        //     let country = ''
        //     try {

        //         country = getAllInfoByISO(element.code)

        //     } catch (error) {
        //         console.log('errrrrrrrrrrrr', error)
        //     }
        //     countries[i].currency = country.currency
        //     countries[i].symbol = country.symbol

        // }

        // console.log('countrycountry', countries)
        // console.log('countrycountry', JSON.parse(JSON.stringify(countries)))
        // console.log('countrycountry', JSON.stringify(countries)
        // let country = getAllInfoByISO(this.props.initData.countryCode)
        // console.log('countrycountry', country)
        document.addEventListener("keydown", this._handleKeyDown);

    }
    componentWillUnmount = () => {
        document.removeEventListener("keydown", this._handleKeyDown);
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.userPostInfo()
        }
    }


    // finalizeUsername = (cb) => {
    //     if (this.form) {
    //         let data = this.form.getForm()
    //         if (/^\w+(\-\w+|\.\w+)?$/.test(data?.username) && data?.username?.length >= 4 && data?.username?.length <= 30) {
    //             // if (false) {


    //             if (data) {
    //                 this.setState({ isLoading: true })

    //                 this.checkUsername(data.username, (valid, err) => {

    //                     if(err){

    //                         this.setState({ errors: { username: err } })
    //                         return
    //                     }

    //                     this.props.setData(data, () => {

    //                         this.props.createProfile((success,nerr)=>{
    //                             this.setState({ isLoading: false })

    //                             if(err){
    //                                 this.setState({ errors: { username: nerr } })
    //                                 return
    //                             }

    //                         })

    //                     })

    //                 })
    //             }

    //         } else {
    //             this.setState({ errors: { username: '{{lang}}errors.usernamePattern' } })
    //         }
    //     }
    // }


    render() {
        return (

            <div className=" flexc flex-column pt-4">
                <div style={{ maxWidth: "400px" }}>
                    {/*  */}
                    <div className='w-100 px-3' >
                        <div className='d-flex mb-2'>
                            {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#33486e" className='cursor-pointer' onClick={() => this.props.lastStage()} style={{ width: 25 }}>
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                            </svg> */}
                            <h2 className="text-title1 mb-0" style={{ fontSize: "24px", fontWeight: '500', cursor: 'default' }}>{translate("information")}</h2>

                        </div>
                        {/* <p className="text-title1 mb-4 mt-0 text-bold" style={{ fontSize: 15 }}>{translate('insert-information')}</p> */}
                    </div>

                    <div className="w-100 px-3" >
                        {console.log('this.props.initData', this.props.initData)}
                        <FormViewer ref={el => this.form = el} headers={this.state.formHeaders} initData={this.props.initData} errors={this.state.errors} inputClass={'phone-input'} nopadding={true} />

                        <div className="d-flex" style={{ justifyContent: "end" }}>

                            {/* <LoaderButton
                                onClick={() => this.userPostInfo()}
                                isLoading={this.state.isLoading}
                                text={translate("signup")}
                                backgroundImage='linear-gradient(45deg, #30A1B8 0%, #5598DE 40%, #8E81F4  70%, #F45495  90%, #EE4358  100%)'
                                shadow="0px 0px 14px -7px #007aff;"
                                icon={'/assets/icons/angle-right-white2.svg'}
                                className={'button-interactive-1'}
                                language={this.props.language}
                            /> */}
                            <ButtonAnimated icon={'/assets/icons/arrow-right-white.svg'} bg={this.props.textColor} title={'Submit'} onClick={this.userPostInfo} isLoading={this.state.isLoading} />

                        </div>

                        {/* <div className="w-100 pt-2">
                            <button className="mb-3" onClick={() => this.props.lastStage()} style={{ fontSize: 13, }}>{translate('back-one-stage')}</button>
                        </div> */}

                    </div>
                </div>
            </div>

        )
    }
}

export default LoginInfoStep;